// components/IndustriesSection.js
import React from 'react';

const industries = [
  {
    title: "Healthcare",
    image: "/industries-1.png"
  },
  {
    title: "Manufacturing",
    image: "/industries-2.png"
  },
  {
    title: "Government and Non-Profit",
    image: "/industries-3.png"
  },
  {
    title: "E-Commerce",
    image: "/industries-4.png"
  },
  {
    title: "Banking and Insurance",
    image: "/industries-5.png"
  },
  {
    title: "Digital and Advertising Agencies",
    image: "/industries-6.png"
  },
];

export default function IndustriesSection() {
  return (
    <section className="bg-orange-600 py-20 text-white" id="industries">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-12 uppercase">Industries We Serve</h2>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="relative h-48 overflow-hidden rounded shadow-lg group"
            >
              <img src={industry.image} alt={industry.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition duration-300" />
                            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                <h3 className="text-lg font-semibold text-white text-center px-2 uppercase">
                  {industry.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
